
export class EntityChangeType {
    
    static NONE = "NONE";
    static UNDEFINED = "UNDEFINED";
    static MINOR = "MINOR";
    static MAJOR = "MAJOR";
}